import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import './themes/theme.scss'
Vue.use(Element, {
  size: 'small'
});




import '@/common/filter.js'
import '@/common/components.js'


import global from '@/global'
Vue.prototype.$g = global;


import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
